import React, { Fragment, useRef, useState } from "react";
import { RxCross2 } from "react-icons/rx";
import html2canvas from "html2canvas";
import { jsPDF } from "jspdf";
import "./Sale.css";
import classNames from "classnames";
import { Menu, Transition } from "@headlessui/react";
import { emailLink } from "../../helpers/util";
import PrintIcon from "../../assets/img/printer.svg";
import ShareIcon from "../../assets/img/share.svg";
import DownloadIcon from "../../assets/img/download.svg";
import ThermalIcon from "../../assets/img/thermal3.svg";
import CheckIcon from "../../assets/img/check-circle.svg";
import { FaMailBulk, FaWhatsapp } from "react-icons/fa";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { AWS_URL, URL, http } from "../../services/http.service";
import {
  momentDateFormat,
  SaleformatDateByBusinessPreference,
} from "../../components/common/utlity/utility";
import { useNavigate, useParams } from "react-router-dom";
import { getHexTimeInSixDigit } from "../../components/common/utlity/sale.utility";
import { getCurrencySymbol } from "../../components/common/utlity/options";
import TallyPrime from "./Tally-prime";
import LandscapeTheme from "./LandscapeTheme";
import LandscapeTheme2 from "./LandscapeTheme2";
import GstTheme1 from "./GstTheme1";
import GstTheme2 from "./GstTheme2";
import GstTheme3 from "./GstTheme3";
import GstTheme4 from "./GstTheme4";
import Theme1 from "./Theme1";
import Theme2 from "./Theme2";
import Theme3 from "./Theme3";
import TaxInvoice1 from "./InvoiceDesign2";
import TaxInvoice2 from "./InvoiceDesign3";
import InvoiceDesign1 from "./InvoiceDesign1";
import DoubleDevine from "./DoubleDevine";
import GreenDoubleDevine from "./greenDoubledevine";
import ModernInvoice from "./ModernInvoice";
import ModernInvoice2 from "./MordernDesign2";
import useTheme from "../../constants/there";
import TraditionalInvoice from "./TraditionalInvoice";
import PDFStyleInvoice from "./pdfStyle";

const SaleInvoice = ({
  close,
  item,
  returnInvoce = false,
  productSections,
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const containerRef = useRef(null);
  const { bussinessUuid } = useParams();
  const businessData = useSelector((state) => state.bussiness.business);
  const business = Array.isArray(businessData)
    ? businessData.find((b) => b.bussinessUuid === item?.bussinessUuid || b.bussinessUuid === bussinessUuid) || businessData[0]
    : businessData;
  const currentBusinessUuid = bussinessUuid || item?.bussinessUuid || business?.bussinessUuid || "";
  const [selectedPrint, setSelectedPrint] = useState(() => {
    const saved = localStorage.getItem(`invoice_template_${currentBusinessUuid}`);
    return saved ? parseInt(saved, 10) : 2;
  });
  const [selectedColor, setSelectedColor] = useState(() => {
    return localStorage.getItem(`invoice_color_${currentBusinessUuid}`) || "bg-pink-400";
  });
  const colors = [
    "bg-green-400",
    "bg-pink-400",
    "bg-blue-400",
    "bg-yellow-400",
    "bg-red-400",
    "bg-cyan-600",
    "bg-sky-800",
    "bg-slate-600",
    "bg-gray-800",
    "bg-lime-300",
    "bg-blue-800",
    "bg-green-700",
    "bg-lime-800",
    "bg-red-500",
    "bg-purple-800",
    "bg-pink-500",
    "bg-amber-800",
    "bg-yellow-700",
    "bg-pink-700",
    "bg-yellow-200",
    "bg-fuchsia-500",
    "bg-rose-950",
    "bg-[#0B5844]",
    "bg-[#00381F]",
    "bg-[#187E5F]",
  ];
  const { themeMode } = useTheme();

  const download = () => {
    const containerElement = containerRef.current;
    if (!containerElement) {
      console.error("Invalid container element.");
      return;
    }

    // Save original styles
    const originalStyles = {
      width: containerElement.style.width,
      height: containerElement.style.height,
      overflow: containerElement.style.overflow,
      position: containerElement.style.position,
    };

    // Set styles for PDF generation
    containerElement.style.width = "210mm";
    containerElement.style.overflow = "visible";
    containerElement.style.position = "relative";

    // Get the actual height of the content
    const contentHeight = containerElement.scrollHeight;

    html2canvas(containerElement, {
      scale: 2,
      useCORS: true,
      allowTaint: true,
      scrollX: 0,
      scrollY: 0,
      height: contentHeight,
      windowHeight: contentHeight,
    })
      .then((canvas) => {
        const imgData = canvas.toDataURL("image/png");
        const pdf = new jsPDF("p", "mm", "a4");

        const pageWidth = 210; // A4 width in mm
        const pageHeight = 297; // A4 height in mm

        // Calculate image dimensions maintaining aspect ratio
        const imgWidth = pageWidth - 10; // 5mm margin on each side
        const imgHeight = (canvas.height * imgWidth) / canvas.width;

        let heightLeft = imgHeight;
        let position = 0;

        // First page
        pdf.addImage(imgData, "PNG", 5, position, imgWidth, imgHeight);
        heightLeft -= pageHeight;

        // Additional pages with proper continuation
        let pageCount = 1;
        while (heightLeft > 0) {
          pdf.addPage();
          pageCount++;
          position = -(pageHeight * pageCount - pageHeight); // Calculate correct position
          pdf.addImage(imgData, "PNG", 5, position, imgWidth, imgHeight);
          heightLeft -= pageHeight;
        }

        pdf.save("invoice.pdf");

        // Restore original styles
        Object.keys(originalStyles).forEach((key) => {
          containerElement.style[key] = originalStyles[key];
        });
      })
      .catch((error) => {
        console.error("Error while capturing the container:", error);
        // Restore original styles
        Object.keys(originalStyles).forEach((key) => {
          containerElement.style[key] = originalStyles[key];
        });
      });
  };

  const userData = useSelector((state) => state.bussiness.business);
  const user = Array.isArray(userData)
    ? userData.find((b) => b.bussinessUuid === item?.bussinessUuid || b.bussinessUuid === bussinessUuid) || userData[0]
    : userData;

  const printPage = () => {
    const containerElement = containerRef.current;
    if (!containerElement) {
      console.error("Invalid container element.");
      return;
    }

    const printWindow = window.open("", "Print", "height=842,width=595"); // A4 size in px approx

    // Base styles for print (you can add your full Tailwind CSS or custom CSS here)
    const styles = `
      @page {
        size: A4;
        margin: 10mm;
      }
      body {
        margin: 0;
        font-family: 'Helvetica', 'Arial', sans-serif;
        font-size: 12px;
        -webkit-print-color-adjust: exact; /* for background colors */
        print-color-adjust: exact;
      }
      /* Example: Avoid style changes for lines 4 to 13 in table body */
      table tbody tr:nth-child(n+4):nth-child(-n+13) {
        background-color: inherit !important;
        color: inherit !important;
        font-weight: normal !important;
      }
      /* Ensure table borders and layout intact */
      table {
        width: 100%;
        border-collapse: collapse;
      }
      table, th, td {
        border: 1px solid #999;
      }
      th, td {
        padding: 4px 8px;
        text-align: center;
      }
    `;

    printWindow.document.write(`<html><head><title>Print</title>`);
    printWindow.document.write(`<style>${styles}</style>`);
    printWindow.document.write(`</head><body>`);
    printWindow.document.write(containerElement.outerHTML);
    printWindow.document.write(`</body></html>`);

    printWindow.document.close();

    // Wait for content to load before print
    printWindow.onload = () => {
      printWindow.focus();
      printWindow.print();
      printWindow.close();
    };
  };
  
  // shareWhatsapp;
  const shareImage = async () => {
    try {
      const canvas = await html2canvas(containerRef?.current, {
        scale: 2,
        useCORS: true, // ✅ Needed for logo / QR cross-origin images
        allowTaint: true,
        scrollX: 0,
        scrollY: 0,
      });

      canvas.toBlob(async (blob) => {
        if (!blob) {
          console.error("Failed to convert canvas to Blob");
          return;
        }

        const filename = `bill_${Date.now()}.png`;
        const formData = new FormData();
        formData.append("image", blob, filename);

        const response = await http.post(
          URL + "/uploadretailRocket/upload",
          formData
        );

        const ImageUrl = response.data.imageUrl;
        if (ImageUrl) {
          const whatsappMessage = `Check out your bill: ${ImageUrl}`;
          const whatsappUrl = `https://api.whatsapp.com/send?text=${encodeURIComponent(
            whatsappMessage
          )}`;
          window.open(whatsappUrl, "_blank");
        } else {
          console.error("Image URL is undefined");
        }
      }, "image/png");
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const shareEmail = () => {
    const containerElement = containerRef?.current;
    let link = emailLink("https://dukkanbuddy.com/324234/sale", {
      subject: "Sale Invoice",
      body: containerElement.innerText,
      separator: " ",
    });
    window.open(link, "blank");
  };

  const {
    businessName,
    address,
    email,
    phone,
    gstNumber,
    pincode,
    aadharPhoto,
  } = user || {};
  const {
    invoiceId,
    mobile,
    deliveryAddress,
    gstNo,
    committedDateToPay,
    items,
    transactionAmount,
    subscriptionDisc,
    additionalFee,
    additionalDiscount,
    deliveryPreference,
    saleType,
    remainingTransactionAmount,
    pickupTime,
    pickupDate,
    igst,
    cgst,
    sgst,
    cess,
    intraState,
  } = item;
  
  const totalAdditionalDiscount = Array.isArray(additionalDiscount)
    ? additionalDiscount.reduce(
        (sum, d) => sum + (parseFloat(d.amount) || 0),
        0
      )
    : 0;

  const totalAdditionalFee = Array.isArray(additionalFee)
    ? additionalFee.reduce((sum, d) => sum + (parseFloat(d.amount) || 0), 0)
    : 0;
    
  const totalInvoiceAmount = item?.items?.reduce((sum, item) => {
    return sum + parseFloat(item?.finalPrice || 0);
  }, 0);
  
  const formatDueDate = (originalDate) => {
    const [year, month, day] = originalDate.split("-");
    return `${day}-${month}-${year}`;
  };
  
  const handleNavigate = () => {
    navigate(`/${item?.bussinessUuid}/dashboard/profile`);
  };

  // Helper function to format variant attributes
  const formatVariantAttributes = (attributes) => {
    if (!attributes || attributes.length === 0) return "";
    return attributes.map(attr => `${attr.name}: ${attr.value}`).join(", ");
  };

  // Helper function to get product display name with variant
  const getProductDisplayName = (product) => {
    if (product.variantName) {
      return (
        <div className="flex flex-col">
          <span>{product.productName}</span>
          <span className="text-xs text-gray-600 dark:text-gray-300">
            ({product.variantName})
            {product.attributes && product.attributes.length > 0 && (
              <span className="ml-1">- {formatVariantAttributes(product.attributes)}</span>
            )}
          </span>
        </div>
      );
    }
    return product.productName;
  };

  const printOptions = [
    { id: 2, label: `2” ${t("COMMON.THERMAL_PRINT")}`, image: ThermalIcon },
    { id: 3, label: `3” ${t("COMMON.THERMAL_PRINT")}`, image: ThermalIcon },
    { id: 4, label: t("INVOICENAME.TALLY_PRIME"), image: 'https://i.postimg.cc/654Wdy4P/tally-Prime-page-0001.jpg' },
    { id: 5, label: t("INVOICENAME.LANDSCAPE THEME 1"), image: 'https://i.postimg.cc/T3GVyytV/landscape-theme-page-0001.jpg' },
    { id: 6, label: t("INVOICENAME.LANDSCAPE THEME 2"), image: 'https://i.postimg.cc/VLssdmjS/landscape-theme2-page-0001.jpg' },
    { id: 7, label: t("INVOICENAME.GST_THEAME 1"), image: 'https://i.postimg.cc/c45cz1hw/gst-theme1-page-0001.jpg' },
    { id: 8, label: t("INVOICENAME.GST_THEAME 2"), image: 'https://i.postimg.cc/NjH0wb6b/gst-theme2-page-0001.jpg' },
    { id: 9, label: t("INVOICENAME.GST_THEAME 3"), image: 'https://i.postimg.cc/dVHg4Kkx/gst-theme3-page-0001.jpg' },
    { id: 10, label: t("INVOICENAME.GST_THEAME 4"), image: 'https://i.postimg.cc/c45cz1hw/gst-theme4-page-0001.jpg' },
    { id: 11, label: t("INVOICENAME.THEAME 1"), image: 'https://i.postimg.cc/c4mJ162t/theme1-page-0001.jpg' },
    { id: 12, label: t("INVOICENAME.THEAME 2"), image: 'https://i.postimg.cc/ZK3M6d40/theme2-page-0001.jpg' },
    { id: 13, label: t("INVOICENAME.THEAME 3"), image: 'https://i.postimg.cc/TwJPyw1s/theme3-page-0001.jpg' },
    { id: 14, label: t("INVOICENAME.THEAME 4"), image: 'https://i.postimg.cc/Mp3LrgfL/theme4a.png' },
    { id: 15, label: t("INVOICENAME.THEAME 5"), image: 'https://i.postimg.cc/3wJt71mv/theme5a.png' },
    { id: 16, label: t("INVOICENAME.THEAME 6"), image: 'https://i.postimg.cc/02zx5GGh/theme6a.png' },
    { id: 17, label: t("INVOICENAME.DOUBLE_DEVINE"), image: 'https://i.postimg.cc/pT54bkMB/devine.png', requiresNoReturn: true },
    { id: 18, label: t("INVOICE.Double Devine 2") || "Double Devine 2", image: 'https://i.postimg.cc/X7bFb4FD/Screenshot-2025-09-28-084358.png', requiresNoReturn: true },
    { id: 19, label: t("    MordenInvoice ") || "Modern Invoice", image: 'https://i.postimg.cc/kgyvZDpW/Screenshot-2025-09-28-084207.png', requiresNoReturn: true },
    { id: 20, label: t("    MordenInvoice2 ") || "Modern Invoice 2", image: 'https://i.postimg.cc/1RwRg0GY/Screenshot-2025-09-28-135802.png', requiresNoReturn: true },
    { id: 21, label: t("    TraditionalInvoice ") || "Traditional Invoice", image: 'https://i.postimg.cc/rp4pxzzH/Screenshot-2025-09-28-150310.png', requiresNoReturn: true },
    { id: 22, label: t("New Invoice") || "New Invoice", image: 'https://i.postimg.cc/rp4pxzzH/Screenshot-2025-09-28-150310.png', requiresNoReturn: true }
  ];

  const filteredPrintOptions = printOptions.filter(
    (option) => !option.requiresNoReturn || returnInvoce === false
  );

  return (
    <div className=' w-full flex '>
      <div className='w-2/3 '>
        {selectedPrint === 4 ? (
          <TallyPrime
            containerRef={containerRef}
            businessName={businessName}
            phone={phone}
            bussiness={user}
            item={item}
            darkMode={themeMode === "dark"}
          />
        ) : selectedPrint === 5 ? (
          <LandscapeTheme
            containerRef={containerRef}
            businessName={businessName}
            phone={phone}
            bussiness={user}
            item={item}
            darkMode={themeMode === "dark"}
          />
        ) : selectedPrint === 6 ? (
          <LandscapeTheme2
            containerRef={containerRef}
            businessName={businessName}
            phone={phone}
            item={item}
            bussiness={user}
            darkMode={themeMode === "dark"}
          />
        ) : selectedPrint === 7 ? (
          <GstTheme1
            containerRef={containerRef}
            businessName={businessName}
            phone={phone}
            item={item}
            bussiness={user}
            selectedColor={selectedColor}
            darkMode={themeMode === "dark"}
          />
        ) : selectedPrint === 8 ? (
          <GstTheme2
            containerRef={containerRef}
            businessName={businessName}
            phone={phone}
            item={item}
            bussiness={user}
            selectedColor={selectedColor}
            darkMode={themeMode === "dark"}
          />
        ) : selectedPrint === 9 ? (
          <GstTheme3
            containerRef={containerRef}
            businessName={businessName}
            phone={phone}
            item={item}
            bussiness={user}
            selectedColor={selectedColor}
            darkMode={themeMode === "dark"}
          />
        ) : selectedPrint === 10 ? (
          <GstTheme4
            containerRef={containerRef}
            businessName={businessName}
            phone={phone}
            item={item}
            bussiness={user}
            selectedColor={selectedColor}
            darkMode={themeMode === "dark"}
          />
        ) : selectedPrint === 11 ? (
          <Theme1
            containerRef={containerRef}
            businessName={businessName}
            phone={phone}
            item={item}
            bussiness={user}
            selectedColor={selectedColor}
            darkMode={themeMode === "dark"}
          />
        ) : selectedPrint === 12 ? (
          <Theme2
            containerRef={containerRef}
            businessName={businessName}
            phone={phone}
            item={item}
            bussiness={user}
            selectedColor={selectedColor}
            darkMode={themeMode === "dark"}
          />
        ) : selectedPrint === 13 ? (
          <Theme3
            containerRef={containerRef}
            businessName={businessName}
            phone={phone}
            item={item}
            bussiness={user}
            selectedColor={selectedColor}
            darkMode={themeMode === "dark"}
          />
        ) : selectedPrint === 14 ? (
          <TaxInvoice1
            containerRef={containerRef}
            businessName={businessName}
            phone={phone}
            item={item}
            selectedColor={selectedColor}
            // darkMode={themeMode === "dark"}
            bussiness={user}
          />
        ) : selectedPrint === 15 ? (
          <TaxInvoice2
            containerRef={containerRef}
            businessName={businessName}
            phone={phone}
            item={item}
            selectedColor={selectedColor}
            // darkMode={themeMode === "dark"}
            bussiness={user}
          />
        ) : selectedPrint === 16 ? (
          <InvoiceDesign1
            containerRef={containerRef}
            businessName={businessName}
            phone={phone}
            item={item}
            selectedColor={selectedColor}
            // darkMode={themeMode === "dark"}
            bussiness={user}
          />
        ) : selectedPrint === 17 ? (
          <DoubleDevine
            containerRef={containerRef}
            businessName={businessName}
            phone={phone}
            item={item}
            // darkMode={themeMode === "dark"}
            bussiness={user}
          />
        ) : selectedPrint === 18 ? (
          <GreenDoubleDevine
            containerRef={containerRef}
            businessName={businessName}
            phone={phone}
            item={item}
            // darkMode={themeMode === "dark"}
            bussiness={user}
          />
        ) : selectedPrint === 19 ? (
          <ModernInvoice
            item={item}
            containerRef={containerRef}
            businessName={businessName}
            phone={phone}
            darkMode={false}
            bussiness={user}
            selectedColor={selectedColor}
          />
        ) : selectedPrint === 20 ? (
          <ModernInvoice2
            item={item}
            containerRef={containerRef}
            businessName={businessName}
            phone={phone}
            darkMode={false}
            bussiness={user}
            selectedColor={selectedColor}
          />
        ) : selectedPrint === 21 ? (
          <TraditionalInvoice
            item={item}
            containerRef={containerRef}
            businessName={businessName}
            phone={phone}
            darkMode={false}
            bussiness={user}
            selectedColor={selectedColor}
          />
        ) : selectedPrint === 22 ? (
          <PDFStyleInvoice
            item={item}
            containerRef={containerRef}
            businessName={businessName}
            phone={phone}
            darkMode={false}
            bussiness={user}
            selectedColor={selectedColor}
          />
        ) : (
          <>
            {!address?.firstLine && (
              <div className='bg-yellow-500'>
                <button
                  onClick={handleNavigate}
                  className='underline font-bold'
                >
                  Click here to add your address for a better invoice.
                </button>
              </div>
            )}
            <div className='' ref={containerRef}>
              <div
                className='bg-white p-1 mt-3 border border-white-800 rounded-lg'
                style={{ width: `${selectedPrint === 2 ? "380px" : "432px"}` }}
              >
                <div className='flex justify-between'>
                  {returnInvoce === true ? (
                    <h4 className='font-bold text-gray-700'>
                      Return {t("SALE.INVOICE")}/Debit Note
                    </h4>
                  ) : (
                    <>
                      {item?.saleType === "estimate" ? (
                        <h4 className='font-bold text-gray-700'>Estimate Invoice</h4>
                      ) : (
                        <h4 className='font-bold text-gray-700'>{t("SALE.INVOICE")}</h4>
                      )}
                      {item?.showGST === false && saleType !== "estimate" && (
                        <div className='mt-5 text-xs text-gray-700'>
                          This is a Non-GST Invoice; cannot use for GST Returns
                        </div>
                      )}

                      {item?.saleType === "advancePayment" && (
                        <div className='mt-5 text-xs text-bold text-gray-700'>
                          This is a Proforma Invoice
                        </div>
                      )}
                      {saleType === "estimate" && item?.showGST === false ? (
                        <span className='font-bold ml-22 text-gray-700'>Non GST</span>
                      ) : (
                        <span className='font-bold ml-22 text-gray-700'>GST</span>
                      )}
                    </>
                  )}
                  <span
                    className='cursor-pointer mb-7 text-gray-700'
                    onClick={() =>
                      close(false, item.saleType === "estimate" ? true : false)
                    }
                  >
                    <RxCross2 />
                  </span>
                </div>
                <div className='flex justify-between '>
                  <div>
                    <p className='font-bold mb-2 text-xs text-gray-900'>{businessName}</p>
                    <p className='text-xs  text-gray-900'>
                      <span className=''>
                        {address?.firstLinebold && <>{address.firstLine}</>}
                        {address?.city || ""},{pincode || ""}, India
                      </span>
                      <br />
                      {t("COMMON.GSTIN_NUMBER")} :{" "}
                      {gstNumber || "Not Available"}
                      <br />
                      {t("COMMON.MOBILE")}: {phone || "0000000000"}
                      <br />
                      {t("COMMON.EMAIL")}: {email || "---"}
                    </p>
                  </div>
                  <div className='text-end'>
                    <p className='font-bold mb-2 text-xs text-gray-900'>
                      {t("COMMON.TAX_INVOICE")}
                    </p>
                    <p className='text-xs text-gray-900'>
                      {t("COMMON.INVOICE_NUMBER")}:{" "}
                      {invoiceId || getHexTimeInSixDigit()} <br />
                      {t("COMMON.INVOICE_DATE")}:{" "}
                      {SaleformatDateByBusinessPreference(
                        item?.saleDate,
                        business?.dateFormat
                      )}
                      <br />
                      {committedDateToPay && (
                        <div className='font-bold text-red-600'>
                          {t("COMMON.PAYMENT_DUE_DATE")}:{" "}
                          {formatDueDate(committedDateToPay)}
                        </div>
                      )}
                    </p>
                    {item?.ewayBillDate && (
                      <div className='text-xs text-gray-900'>
                        <div>ewayBillDate: {item?.ewayBillDate}</div>
                      </div>
                    )}

                    {item?.ewayBillNo && (
                      <div className='text-xs text-gray-900'>
                        <div>ewayBillNo: {item?.ewayBillNo}</div>
                      </div>
                    )}

                    {item?.validUpto && (
                      <div className='text-xs text-gray-900'>
                        <div>validUpto: {item?.validUpto}</div>
                      </div>
                    )}
                  </div>
                </div>
                <h1 className='my-1 font-bold text-xs text-gray-900'>
                  {t("COMMON.CUSTOMER")}: {item?.customerName}
                </h1>
                <h1 className='my-1 font-bold text-xs text-gray-900'>
                  {t("COMMON.MOBILE")}: {mobile || "00000000"}
                </h1>

                <div className='flex justify-between'>
                  <div className='text-xs text-gray-900'>
                    <p className='font-bold mb-2 text-gray-900'>
                      {t("COMMON.CUSTOMER_ADDRESS")}
                    </p>
                    <p>
                      {item?.address || "----"} <br />
                      {`${item?.state || ""}, ${item?.country || ""}`} <br />
                      {t("COMMON.GSTIN_NUMBER")}: {gstNo || "No-GST"}
                    </p>
                  </div>
                  {deliveryAddress && (
                    <div className='text-end text-xs text-gray-900'>
                      <p className='font-bold mb-2'>
                        {t("COMMON.DELIVERY_ADDRESS")}
                      </p>
                      <p>
                        {deliveryAddress || "----"}
                        <br />
                      </p>
                    </div>
                  )}
                </div>

                <div className=''>
                  {item.saleType === "advancePayment" && items?.length <= 0 ? (
                    <>Items will decide later</>
                  ) : (
                    <table className='w-full text-start mt-3'>
                      <thead className='text-xs text-gray-900'>
                        <tr>
                          <th>No.</th>
                          <th>{t("COMMON.NAME")}</th>
                          <th>{t("COMMON.QTY")}</th>
                          <th>{t("COMMON.DIS")}</th>
                          {intraState === true ? (
                            <th>{t("TAX_WITHOUT_PERC.IGST")}</th>
                          ) : (
                            <>
                              <th>{t("TAX_WITHOUT_PERC.CGST")}</th>
                              <th>{t("TAX_WITHOUT_PERC.SGST")}</th>
                            </>
                          )}
                          <th>{t("TAX_WITHOUT_PERC.CESS")}</th>
                          <th>{t("TAX.SALE_PRICE")}</th>
                          <th>{t("COMMON.TOTAL")}</th>
                        </tr>
                      </thead>
                      <tbody className='text-xss text-gray-900'>
                        {returnInvoce === true ? (
                          item?.returnitems?.length > 0 ? (
                            item.returnitems.map((data, index) => (
                              <tr key={index}>
                                <td>{index + 1}</td>
                                <td>
                                  {data.variantName ? (
                                    <div className="flex flex-col">
                                      <span>{data.productName}</span>
                                      <span className="text-xs text-gray-900">
                                        ({data.variantName})
                                      </span>
                                    </div>
                                  ) : (
                                    data.productName
                                  )}
                                </td>
                                <td>{data.quantity}</td>
                                <td>{data.discount} ₹</td>
                                {intraState === true ? (
                                  <td>{data.igst} %</td>
                                ) : (
                                  <>
                                    <td>{data.cgst} %</td>
                                    <td>{data.sgst_utgst} %</td>
                                  </>
                                )}
                                <td>{data.cess} %</td>
                                <td>
                                  {getCurrencySymbol(business?.currency)}
                                  {data.salePrice}
                                </td>
                                <td>
                                  {getCurrencySymbol(business?.currency)}
                                  {data.finalPrice}
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan='9'>No return items available.</td>
                            </tr>
                          )
                        ) : items?.length > 0 ? (
                          items.map((data, index) => (
                            <tr key={`${data.productId}-${data.variantId || 'novariant'}-${index}`}>
                              <td>{index + 1}</td>
                              <td className="text-left text-gray-900">
                                <div className="flex flex-col">
                                  <span className="font-medium">{data.productName}</span>
                                  {data.variantName && (
                                    <span className="font-medium text-gray-900  mt-1">
                                       {data.variantName}
                                      {data.attributes && data.attributes.length > 0 && (
                                        <span className="block font-medium text-gray-500">
                                          {formatVariantAttributes(data.attributes)}
                                        </span>
                                      )}
                                    </span>
                                  )}
                              
                                </div>
                              </td>
                              <td>{data.quantity}</td>
                              <td>
                                {data.discount} 
                                {data.discountUnit === "percentage" ? "%" : "₹"}
                              </td>
                              {intraState === true ? (
                                <td>{data.igst || 0}%</td>
                              ) : (
                                <>
                                  <td>{data.cgst || 0}%</td>
                                  <td>{data.sgst_utgst || 0}%</td>
                                </>
                              )}
                              <td>{data.cess || 0}%</td>
                              <td>
                                {getCurrencySymbol(business?.currency)}
                                {data.salePrice || data.finalPrice/data.quantity}
                              </td>
                              <td>
                                {getCurrencySymbol(business?.currency)}
                                {data.finalPrice}
                              </td>
                            </tr>
                          ))
                        ) : productSections.length > 0 ? (
                          productSections.map((data, index) => (
                            <tr key={index}>
                              <td>{index + 1}</td>
                              <td>
                                {data.variantName ? (
                                  <div className="flex flex-col">
                                    <span>{data.productName}</span>
                                    <span className="text-xs text-gray-900">
                                      ({data.variantName})
                                    </span>
                                  </div>
                                ) : (
                                  data.productName
                                )}
                              </td>
                              <td>{data.quantity}</td>
                              <td>{data.discount} ₹</td>
                              <td>{data.gstPercent} %</td>
                              <td>
                                {getCurrencySymbol(business?.currency)}
                                {data.salePrice}
                              </td>
                              <td>
                                {getCurrencySymbol(business?.currency)}
                                {data.finalPrice}
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan='9'>No items available.</td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  )}
                </div>
                <div className='w-full flex justify-end mt-3 text-xs text-gray-900'>
                  <div className='w-1/2'>
                    {saleType === "homeDelivery" && (
                      <>
                        <div>{t("SIDER.EXPECTED_DELIVERY")}:</div>
                        <div>
                          {momentDateFormat(deliveryPreference?.deliveryDate)}
                        </div>
                      </>
                    )}
                    {saleType === "shedulePickup" && pickupDate && (
                      <>
                        <div>{t("SIDER.PICKUP_DATE")}</div>
                        <div>{momentDateFormat(pickupDate)}</div>
                        <div>{t("SIDER.PICKUP_TIME")}</div>
                        <div>{pickupTime}</div>
                      </>
                    )}
                    {intraState === true ? (
                      <div className='flex border-b p-1'>
                        <div className=' font-bold'>
                          {t("TAX_WITHOUT_PERC.IGST")}:{igst || 0}
                        </div>
                      </div>
                    ) : (
                      <>
                        <div className='flex border-b p-1'>
                          <div className=' font-bold'>
                            {t("TAX_WITHOUT_PERC.CGST")}:{cgst || 0}
                          </div>
                        </div>
                        <div className='flex border-b p-1'>
                          <div className=' font-bold'>
                            {t("TAX_WITHOUT_PERC.SGST")}:{sgst || 0}
                          </div>
                        </div>
                      </>
                    )}

                    {cess && (
                      <div className='flex border-b p-1'>
                        <div className=' font-bold'>
                          {t("TAX_WITHOUT_PERC.CESS")}:{cess || 0}
                        </div>
                      </div>
                    )}
                    {business.aadharPhoto && (
                      <div class='flex items-center justify-center p-4 bg-gray-100 rounded-lg'>
                        <img
                          src={AWS_URL + business.aadharPhoto}
                          alt='Payment QR Code'
                          class='w-30 object-contain'
                        />
                      </div>
                    )}
                  </div>

                  <div className='w-1/2 border '>
                    {totalAdditionalFee > 0 && (
                      <div className='flex  border-b p-1'>
                        <div className='w-1/2 font-bold'>
                          {t("INVOICE.ADDITIONAL_FEE")}
                        </div>

                        <div className='w-1/2 text-end font-bold'>
                          {getCurrencySymbol(business?.currency)}
                          {totalAdditionalFee || 0}
                        </div>
                      </div>
                    )}
                    {remainingTransactionAmount > 0 && (
                      <>
                        <div className='flex  border-b p-1'>
                          <div className='w-1/2 font-bold'>Paid Balance</div>
                          <div className='w-1/2 text-end font-bold'>
                            {getCurrencySymbol(business?.currency)}
                            {(
                              (parseFloat(transactionAmount) || 0) -
                              (parseFloat(remainingTransactionAmount) || 0)
                            ).toFixed(2)}
                          </div>
                        </div>
                        <div className='flex  border-b p-1'>
                          <div className='w-1/2 font-bold'>Dues Balance</div>
                          <div className='w-1/2 text-end font-bold'>
                            {getCurrencySymbol(business?.currency)}
                            {remainingTransactionAmount || 0}
                          </div>
                        </div>
                      </>
                    )}
                    {totalAdditionalDiscount > 0 && (
                      <div className='flex  border-b p-1'>
                        <div className='w-1/2 font-bold'>
                          {t("INVOICE.ADDITIONAL_DISCOUNT")}
                        </div>

                        <div className='w-1/2 text-end font-bold'>
                          {getCurrencySymbol(business?.currency)}
                          {totalAdditionalDiscount || 0}
                        </div>
                      </div>
                    )}
                    {(item?.saleType === "advancePayment" ||
                      item?.saleType === "advanceSale") && (
                      <div className='flex  border-b p-1'>
                        <div className='w-1/2 font-bold'>
                          Advance Amount
                        </div>
                        <div className='w-1/2 text-end font-bold'>
                          <>
                            {getCurrencySymbol(business?.currency)}
                            {item?.advancePayment || 0}
                          </>
                        </div>
                      </div>
                    )}
                    <div className='flex  border-b p-1'>
                      {item?.saleType === "advancePayment" ? (
                        <>
                          <div className='w-1/2 font-bold'>
                            Remaining Balance
                          </div>
                        </>
                      ) : (
                        <div className='w-1/2 font-bold'>
                          {t("COMMON.TOTAL_VALUE")}
                        </div>
                      )}

                      <div className='w-1/2 text-end font-bold'>
                        {returnInvoce === true ? (
                          <>
                            {" "}
                            {getCurrencySymbol(business?.currency)}
                            {item?.totalReturnAmount}
                          </>
                        ) : (
                          <>
                            {" "}
                            {getCurrencySymbol(business?.currency)}
                            {(
                              totalInvoiceAmount -
                              parseFloat(item?.advancePayment || 0)
                            ).toFixed(2)}
                          </>
                        )}
                      </div>
                    </div>
                    {subscriptionDisc > 0 && (
                      <div className='flex  border-b p-1'>
                        <div className='w-1/2 font-bold'>
                          {t("INVOICE.SUBSCRIPTION_SAVINGS")}
                        </div>

                        <div className='w-1/2 text-end font-bold'>
                          {getCurrencySymbol(business?.currency)}
                          {subscriptionDisc || 0}
                        </div>
                      </div>
                    )}
                    {item?.orderCouponDiscount > 0 && (
  <div className='flex  border-b p-1'>
    <div className='w-1/2 font-bold'>
      {t("COUPON.COUPON_DISCOUNT")} ({item?.orderCouponName})
    </div>
    <div className='w-1/2 text-end font-bold text-green-600'>
      - {getCurrencySymbol(business?.currency)}
      {item?.orderCouponDiscount?.toFixed(2) || 0}
    </div>
  </div>
)}

                    <div className='flex  border-b p-1'>
                      <div className='w-1/2 font-bold'>
                        {t("COMMON.TOTAL_AMOUNT")}
                      </div>

                      <div className='w-1/2 text-end font-bold'>
                        {subscriptionDisc ? (
                          <>
                            {getCurrencySymbol(business?.currency)}
                            {transactionAmount.toFixed(2) || 0}
                          </>
                        ) : returnInvoce === true ? (
                          <>
                            {getCurrencySymbol(business?.currency)}
                            {item?.totalReturnAmount}
                          </>
                        ) : item?.advancePayment ? (
                          <>
                            {getCurrencySymbol(business?.currency)}
                            {item?.transactionAmount}
                          </>
                        ) : (
                          <>
                            {getCurrencySymbol(business?.currency)}
                            {totalInvoiceAmount || 0}
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                {item.notes && <span className='text-xs text-gray-900'>{item.notes}</span>}
              </div>
            </div>
          </>
        )}
      </div>

      <div className='w-1/3 p-4 bg-gray-50/30 dark:bg-[#0b0619]/40 border-l border-gray-200/80 dark:border-[#22163b]/70 flex flex-col h-[calc(100vh-60px)] min-h-0'>
        <style>{`
          .custom-scrollbar-invoice::-webkit-scrollbar {
            width: 5px;
          }
          .custom-scrollbar-invoice::-webkit-scrollbar-track {
            background: transparent;
          }
          .custom-scrollbar-invoice::-webkit-scrollbar-thumb {
            background: #cbd5e1;
            border-radius: 4px;
          }
          .dark .custom-scrollbar-invoice::-webkit-scrollbar-thumb {
            background: #334155;
          }
        `}</style>
        
        {/* Top Actions: Print, Download, Share */}
        <div className='flex gap-2.5 pb-4 border-b border-gray-150 dark:border-gray-800/60'>
          <button
            className='flex-1 px-3 py-2 bg-emerald-600 hover:bg-emerald-700 active:bg-emerald-800 text-white font-medium rounded-xl flex items-center justify-center gap-1.5 transition-all duration-200 shadow-sm shadow-emerald-600/10 hover:shadow-lg hover:shadow-emerald-600/20 transform hover:-translate-y-0.5 active:translate-y-0 focus:outline-none'
            onClick={printPage}
            type="button"
          >
            <img src={PrintIcon} alt='' className='w-4.5 h-4.5 invert' />
            <span className='text-xs font-semibold'>{t("COMMON.PRINT")}</span>
          </button>
          
          <button
            className='flex-1 px-3 py-2 bg-blue-600 hover:bg-blue-700 active:bg-blue-800 text-white font-medium rounded-xl flex items-center justify-center gap-1.5 transition-all duration-200 shadow-sm shadow-blue-600/10 hover:shadow-lg hover:shadow-blue-600/20 transform hover:-translate-y-0.5 active:translate-y-0 focus:outline-none'
            onClick={download}
            type="button"
          >
            <img src={DownloadIcon} alt='' className='w-4.5 h-4.5 invert' />
            <span className='text-xs font-semibold'>{t("COMMON.DOWNLOAD")}</span>
          </button>

          <Menu as='div' className='relative flex'>
            <Menu.Button className='px-3 py-2 bg-indigo-600 hover:bg-indigo-700 active:bg-indigo-800 text-white font-medium rounded-xl flex items-center justify-center gap-1.5 transition-all duration-200 shadow-sm shadow-indigo-600/10 hover:shadow-lg hover:shadow-indigo-600/20 transform hover:-translate-y-0.5 active:translate-y-0 focus:outline-none h-full' type="button">
              <img src={ShareIcon} alt='' className='w-4.5 h-4.5 invert' />
              <span className='text-xs font-semibold'>{t("COMMON.SHARE")}</span>
            </Menu.Button>
            <Transition
              as={Fragment}
              enter='transition ease-out duration-100'
              enterFrom='transform opacity-0 scale-95'
              enterTo='transform opacity-100 scale-100'
              leave='transition ease-in duration-75'
              leaveFrom='transform opacity-100 scale-100'
              leaveTo='transform opacity-0 scale-95'
            >
              <Menu.Items className='origin-top-right z-30 absolute right-0 mt-10 w-44 rounded-xl shadow-xl p-1 bg-white dark:bg-gray-800 ring-1 ring-black ring-opacity-5 focus:outline-none border border-gray-100 dark:border-gray-700'>
                <Menu.Item>
                  {({ active }) => (
                    <div
                      className={classNames(
                        "rounded-lg flex items-center px-3 py-2 text-xs font-medium cursor-pointer transition-colors gap-2",
                        active
                          ? "text-emerald-700 bg-emerald-50 dark:text-emerald-300 dark:bg-emerald-950/30"
                          : "text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700/50"
                      )}
                      onClick={shareImage}
                    >
                      <FaWhatsapp className='text-emerald-600 text-sm' />
                      {t("COMMON.WHATSAPP")}
                    </div>
                  )}
                </Menu.Item>
                <Menu.Item>
                  {({ active }) => (
                    <div
                      className={classNames(
                        "rounded-lg flex items-center px-3 py-2 text-xs font-medium cursor-pointer transition-colors gap-2",
                        active
                          ? "text-blue-700 bg-blue-50 dark:text-blue-300 dark:bg-blue-950/30"
                          : "text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700/50"
                      )}
                      onClick={shareEmail}
                    >
                      <FaMailBulk className='text-blue-600 text-sm' />
                      {t("COMMON.EMAIL")}
                    </div>
                  )}
                </Menu.Item>
              </Menu.Items>
            </Transition>
          </Menu>
        </div>

        {/* Customer Detail Card */}
        <div className='mt-4 p-3.5 bg-gradient-to-br from-indigo-50/60 to-blue-50/40 dark:from-indigo-950/20 dark:to-blue-950/10 rounded-2xl border border-indigo-100/50 dark:border-indigo-900/30 flex justify-between items-center shadow-sm'>
          <div className='min-w-0'>
            <p className='text-[10px] font-bold text-indigo-500 dark:text-indigo-400 uppercase tracking-wider'>
              {t("COMMON.CUSTOMER") || "Customer"}
            </p>
            <h4 className='font-bold text-gray-800 dark:text-white text-sm truncate mt-0.5'>
              {item?.customerName || "Walk-in Customer"}
            </h4>
          </div>
          <div className='text-right'>
            <p className='text-[10px] font-bold text-gray-400 dark:text-gray-500 uppercase tracking-wider'>
              {t("COMMON.TOTAL_AMOUNT") || "Total"}
            </p>
            <h4 className='font-bold text-gray-900 dark:text-white text-base mt-0.5'>
              {transactionAmount}
            </h4>
          </div>
        </div>

        {/* Color Palette Picker */}
        <div className='flex flex-col gap-2 p-3 bg-white dark:bg-white/5 rounded-2xl border border-gray-150 dark:border-gray-800/40 mt-3 shadow-sm'>
          <div className='flex justify-between items-center px-0.5'>
            <span className='text-[10px] font-bold text-gray-400 dark:text-gray-500 uppercase tracking-wider'>
              {t("COMMON.CHOOSE_COLOR") || "Accent Color"}
            </span>
            <span className='text-[10px] font-medium text-gray-500 dark:text-gray-400 capitalize'>
              {selectedColor.replace('bg-', '').replace('-400', '').replace('-500', '').replace('-600', '').replace('-700', '').replace('-800', '')}
            </span>
          </div>
          <div className='flex flex-wrap gap-2 py-0.5 justify-start'>
            {colors.map((color, idx) => (
              <button
                key={idx}
                className={`${color} w-5 h-5 rounded-full cursor-pointer transition-all duration-200 hover:scale-110 active:scale-95 focus:outline-none relative
                  ${selectedColor === color ? "ring-2 ring-offset-2 ring-indigo-600 dark:ring-offset-gray-900" : "hover:ring-1 hover:ring-offset-1 hover:ring-gray-300 dark:hover:ring-offset-gray-800"}`}
                onClick={() => setSelectedColor(color)}
                aria-label={`Select accent color`}
                type="button"
              >
                {selectedColor === color && (
                  <span className="absolute inset-0 flex items-center justify-center text-white text-[10px] font-bold">✓</span>
                )}
              </button>
            ))}
          </div>
        </div>

        {/* Scrollable Templates List */}
        <div className='mt-4 flex flex-col gap-2.5 flex-1 min-h-0 overflow-y-auto pr-1.5 custom-scrollbar-invoice'>
          <div className='text-[10px] font-bold text-gray-400 dark:text-gray-500 uppercase tracking-wider px-1'>
            {t("INVOICE.SELECT_TEMPLATE") || "Print Templates"}
          </div>
          
          <div className='grid grid-cols-2 gap-3.5 pb-6'>
            {filteredPrintOptions.map((option) => (
              <div
                key={option.id}
                className={classNames(
                  "flex flex-col rounded-2xl overflow-hidden border cursor-pointer transition-all duration-305 group relative",
                  selectedPrint === option.id
                    ? "border-indigo-600 bg-indigo-50/10 dark:border-indigo-500 dark:bg-indigo-950/10 shadow-md shadow-indigo-600/5"
                    : "border-gray-150 bg-white hover:border-gray-300 dark:border-gray-850 dark:bg-gray-900 dark:hover:border-gray-805 shadow-sm"
                )}
                onClick={() => setSelectedPrint(option.id)}
              >
                {/* Selected circular check badge */}
                {selectedPrint === option.id && (
                  <div className='absolute top-2 right-2 bg-indigo-600 dark:bg-indigo-500 rounded-full p-1 shadow-md z-10 flex items-center justify-center w-6 h-6 border border-white dark:border-gray-800 animate-scale-in'>
                    <img
                      src={CheckIcon}
                      alt='selected'
                      className='w-3 h-3 invert'
                    />
                  </div>
                )}

                {/* Preview Image Frame */}
                <div className={classNames(
                  'h-30 flex items-center justify-center p-2 relative overflow-hidden transition-all duration-300',
                  selectedPrint === option.id ? 'bg-indigo-50/20 dark:bg-indigo-950/20' : 'bg-gray-50 dark:bg-gray-950/40'
                )}>
                  <img
                    src={option.image}
                    alt={option.label}
                    className='max-w-full max-h-full object-contain rounded transition-transform duration-300 group-hover:scale-105 filter drop-shadow-sm'
                    onError={(e) => {
                      e.target.src = ThermalIcon;
                    }}
                  />
                </div>

                {/* Card footer label */}
                <div className={classNames(
                  'p-2 text-center border-t text-[10px] font-bold truncate transition-colors',
                  selectedPrint === option.id 
                    ? 'bg-indigo-600 text-white border-indigo-600 dark:bg-indigo-500 dark:border-indigo-500' 
                    : 'bg-white text-gray-700 border-gray-100 dark:bg-gray-900 dark:text-gray-300 dark:border-gray-800/80 group-hover:text-indigo-600 dark:group-hover:text-indigo-400'
                )}>
                  {option.label || option.labelFallback}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SaleInvoice;